import React, { useContext } from 'react';
import DrawerContext from './DrawerContext';
var withDrawer = function (ComponentToWrap) { return function (props) {
    var _a = useContext(DrawerContext) || {}, openDrawer = _a.openDrawer, closeDrawer = _a.closeDrawer;
    return <ComponentToWrap {...props} openDrawer={openDrawer} closeDrawer={closeDrawer}/>;
}; };
export default withDrawer;
